import { render, staticRenderFns } from "./io.vue?vue&type=template&id=117e6539&scoped=true&"
import script from "./io.vue?vue&type=script&lang=js&"
export * from "./io.vue?vue&type=script&lang=js&"
import style0 from "./io.vue?vue&type=style&index=0&id=117e6539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e6539",
  null
  
)

export default component.exports